<template>
  <div class="header-main">
    <div class="main-logo">
      <router-link :to="{name: 'mainPage'}">
        <img :src="logo" alt="Logo">
      </router-link>
    </div>
    <div class="menu-button-content">
      <div class="menu-button">
        <menu-icon title="open" @click.native="clickSmMenu"/>
      </div>
    </div>
      <div v-if="user">
        <SearchMultiInput :types="searchOptions" :selectedType="searchOptions[0]" :class="{'search-open':searchBlock}"/>
        <SearchIcon v-if="!searchBlock"/>
<div class = "header-nav">
 <DropdownMenu v-if="user" :class="{'scrolled': scrolled}" :links="['Kategorie', 'Producenci']">
        <template slot="Kategorie">
          <CategoriesIcons/>
        </template>
        <template slot="Producenci">
          <BrandsIcon/>
        </template>
      </DropdownMenu>
  <ul class = "list-inline navitems">
  <li class = "list-inline-item"> <router-link class = "account-icons" v-if="!searchBlock" :to="{name: 'cart'}">Koszyk</router-link></li>
  <li class = "list-inline-item"><a href ="/offer" class = "account-icons" v-if="offerEnable && !searchBlock">Oferta</a></li>
  <li class = "list-inline-item"> <router-link class = "account-icons" v-if="!searchBlock" :to="{name: 'account'}">Moje konto</router-link></li>
  <li class = "list-inline-item"><a href ="#" class = "account-icons" v-if="!searchBlock" @click = "logout()">Wyloguj</a></li>
</ul>
     </div> 
      </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import DropdownMenu from "redbay-b2b-layout/src/navigation/DropdownMenu.vue";
import CategoriesIcons from "redbay-b2b-categories/src/CategoriesIcon.vue";
import BrandsIcon from "redbay-b2b-brands/src/BrandsIcon.vue";
import SearchMultiInput from "redbay-b2b-layout/src/input/SearchMultiInput.vue";
import UserDropDownButton from "redbay-b2b-layout/src/button/UserDropDownButton.vue";
import MenuIcon from "vue-material-design-icons/Menu.vue";
import SearchIcon from "redbay-b2b-layout/src/button/SearchIcon.vue"
import { storeEmitter } from "../../state/store";

export default {
  components: {
    DropdownMenu,
    CategoriesIcons,
    BrandsIcon,
    SearchMultiInput,
    UserDropDownButton,
    MenuIcon,
    SearchIcon
  },
  computed: {
    ...mapState({
      user: state => state.user.authorizedUser,
      searchBlock: state => state.searchBlock,
    })
  },
  props: ["scrolled"],
  data() {
    return {
      logo: "",
      searchOptions: ""
    };
  },
  methods: {
    clickSmMenu() {
      storeEmitter.emit("open-sm");
    },
     async logout() {
        await this.$store.dispatch('user/signout');
        this.$router.go('/');
      },
  },
  beforeMount() {
    this.logo = this.$config.get("header.main.logo");
    this.searchOptions = this.$config.get("header.main.searchOptions");
    this.offerEnable = this.$config.get('offer.enable');

  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/HeaderMain.vue